// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "client") return "static/js/" + chunkId + ".js";
	// return url for filenames based on template
	return "static/js/" + chunkId + ".chunk.js";
};